export default {
    adminAccount: {},
    accountList: [],
    accountListCount: 0,
}